import { combineReducers } from 'redux';

import loadingReducer from 'modules/global/reducers/generic.loading';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

/**
 * @typedef {{
 *  search: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *  loading: boolean,
 * }} InterventionImportStockReducer
 */

export default combineReducers({
  search: createSearchReducers(types.INTERVENTIONS_FETCH, {
    ids: {
      [LOCATION_CHANGE]: () => [],
    },
    global: { matcher: ({ meta }) => meta.source === 'importChecklistGroup' },
  }),
  loading: loadingReducer(types.IMPORT_CHECKLISTS_GROUPS),
});
